import { render, staticRenderFns } from "./Zcap2.vue?vue&type=template&id=4c3ed346&scoped=true&"
import script from "./Zcap2.vue?vue&type=script&lang=ts&"
export * from "./Zcap2.vue?vue&type=script&lang=ts&"
import style0 from "./Zcap2.vue?vue&type=style&index=0&id=4c3ed346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ed346",
  null
  
)

export default component.exports